import { useCallback, useState } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { isBadRequestError } from '@/core/api/badRequestError';
import { manualPaymentConfirmationService } from '@/entities/Payment/api/manualPaymentConfirmationService';
import { manualPaymentConfirmFormToRequest } from '@/entities/Payment/manualPaymentConfirmMappers';
import type { ManualPaymentConfirmFormValues } from '@/entities/Payment/model/manualPaymentConfirmSchema';
import { getErrorMessage } from '@/shared/lib/errors';

/** Отправляет ручное подтверждение оплаты и хранит результат операции. */
export const useManualConfirmSubmit = (form: UseFormReturn<ManualPaymentConfirmFormValues>) => {
    const [completed, setCompleted] = useState(false);

    /** Подтверждает оплату и показывает ошибку запроса в форме. */
    const onSubmit = useCallback(async (values: ManualPaymentConfirmFormValues) => {
        form.clearErrors('root.server');

        try {
            await manualPaymentConfirmationService.confirm(manualPaymentConfirmFormToRequest(values));
            form.reset(values);
            setCompleted(true);
        } catch (error: unknown) {
            if (isBadRequestError(error)) return;

            form.setError('root.server', {
                type: 'server',
                message: getErrorMessage(error, 'Не удалось подтвердить оплату'),
            });
        }
    }, [form]);

    /** Сбрасывает результат предыдущего подтверждения. */
    const resetCompleted = useCallback(() => setCompleted(false), []);

    return {
        onSubmit,
        completed,
        resetCompleted
    };
};
